"use client";
import type { FC, PropsWithChildren } from "react";
import { usePathname } from "next/navigation";
import posthog from "posthog-js";
import { Link, useTransitionRouter } from "next-view-transitions";
import { clsx } from "clsx";
import { faLock, faSignOut, faUser } from "@fortawesome/pro-solid-svg-icons";

import { Icon } from "~/client/components/widgets/Icon";
import { logoutUser } from "~/client/services/data/auth";

import "./styles.scss";

const Settings: FC<PropsWithChildren> = ({ children }) => {
	const router = useTransitionRouter();
	const pathname = usePathname();

	const handleLogout = async () => {
		await logoutUser();
		posthog.reset();
		router.replace("/login");
	};

	return (
		<div className="settings">
			<div className="settings__container">
				<div className="settings__links">
					<div className="settings__links__top">
						<Link
							className={clsx(
								"settings__link",
								pathname?.includes("profile") && "settings__link--active"
							)}
							href="/settings/profile"
						>
							<Icon icon={faUser} />
							&nbsp;Profile
						</Link>
						<Link
							className={clsx(
								"settings__link",
								pathname?.includes("password") && "settings__link--active"
							)}
							href="/settings/password"
						>
							<Icon icon={faLock} />
							&nbsp;Password
						</Link>
					</div>
					<div className="settings__links__bottom">
						<button
							className="settings__logout"
							onClick={handleLogout}
							type="button"
						>
							Logout <Icon icon={faSignOut} />
						</button>
					</div>
				</div>
				<div className="settings__form-container">{children}</div>
			</div>
		</div>
	);
};

export default Settings;
